import type { FC, PropsWithChildren } from 'react'
import type { CustomReportDataProvider } from '#features/Feedback/buildReport'
import { InternalCustomerReportContext } from './InternalCustomerReportContext'

export interface CustomReportContextType {
  reportDataProviders?: Set<CustomReportDataProvider>
}

export const CustomReportDataContext: FC<PropsWithChildren> = ({ children }) => {
  const contextValue: CustomReportContextType = {
    reportDataProviders: new Set<CustomReportDataProvider>(),
  }

  return <InternalCustomerReportContext.Provider value={contextValue}>{children}</InternalCustomerReportContext.Provider>
}
